import { useCallback, useEffect, useState } from "react";
import { toast } from "sonner";
import api, { fmtErr, API } from "../../lib/api";
import { PageHeader, btnPrimary, btnGhost, EmptyState } from "../../components/bits";
import { ShieldCheck, Download, BellRing, Search } from "lucide-react";
import { inputCls } from "../../components/bits";

export default function AdminPledges() {
  const [items, setItems] = useState(null);
  const [q, setQ] = useState("");
  const [busy, setBusy] = useState(false);

  const load = useCallback(() => api.get("/admin/pledges").then((r) => setItems(r.data)).catch((e) => toast.error(fmtErr(e))), []);
  useEffect(() => { load(); }, [load]);

  const remind = async () => {
    setBusy(true);
    try {
      const { data } = await api.post("/admin/pledges/remind");
      toast.success(`تم إرسال التنبيه إلى ${data.reminded} منسقاً غير موثّق`);
    } catch (e) { toast.error(fmtErr(e)); } finally { setBusy(false); }
  };

  const filtered = (items || []).filter((u) =>
    !q || u.name.includes(q) || (u.school_name || "").includes(q) || (u.email || "").includes(q));
  const accepted = (items || []).filter((u) => u.pledge_accepted).length;

  if (items === null) return <div className="text-center text-mutext py-20 font-head">جارٍ التحميل …</div>;

  return (
    <div data-testid="admin-pledges-page">
      <PageHeader title="سجل التعهدات" sub="المنسقون الذين وثّقوا تعهّد صدق البيانات وتاريخه — للمتابعة الإدارية">
        <button data-testid="pledges-remind-btn" onClick={remind} disabled={busy} className={btnGhost}>
          <BellRing className="w-4 h-4" /> {busy ? "جارٍ الإرسال …" : "تنبيه غير الموثّقين"}
        </button>
        <button data-testid="pledges-export-btn" onClick={() => window.open(`${API}/admin/pledges/export`, "_blank")} className={btnPrimary}>
          <Download className="w-4 h-4" /> تصدير Excel
        </button>
      </PageHeader>

      <div data-testid="pledges-counter" className="bg-turq-900 text-white rounded-2xl px-5 py-4 mb-5 flex items-center gap-3 shadow-md">
        <ShieldCheck className="w-6 h-6 shrink-0" />
        <span className="font-head font-bold text-sm">وثّق التعهد {accepted} من أصل {items.length} منسقاً</span>
      </div>

      <div className="relative mb-5 max-w-md">
        <Search className="w-4 h-4 absolute right-3 top-3 text-mutext" />
        <input data-testid="pledges-search" value={q} onChange={(e) => setQ(e.target.value)}
          placeholder="ابحث بالاسم أو المدرسة أو البريد…" className={`${inputCls} pr-9`} />
      </div>

      {filtered.length === 0 ? (
        <EmptyState testid="pledges-empty" text="لا توجد سجلات مطابقة" />
      ) : (
        <div className="bg-surface rounded-2xl border border-brd shadow-md overflow-hidden">
          <div className="overflow-auto">
            <table className="w-full text-sm" data-testid="pledges-table">
              <thead>
                <tr className="bg-bg text-mutext">
                  <th className="text-right px-4 py-2.5 font-head text-[11px]">المنسق</th>
                  <th className="text-right px-4 py-2.5 font-head text-[11px]">المدرسة</th>
                  <th className="text-right px-4 py-2.5 font-head text-[11px]">البريد</th>
                  <th className="text-right px-4 py-2.5 font-head text-[11px]">الجوال</th>
                  <th className="text-right px-4 py-2.5 font-head text-[11px]">حالة التعهد</th>
                  <th className="text-right px-4 py-2.5 font-head text-[11px]">تاريخ التوثيق</th>
                </tr>
              </thead>
              <tbody>
                {filtered.map((u) => (
                  <tr key={u.id} data-testid={`pledge-row-${u.id.slice(0, 8)}`} className="border-b border-brd/50 last:border-0 hover:bg-bg transition-colors">
                    <td className="px-4 py-3 font-bold">{u.name}</td>
                    <td className="px-4 py-3">{u.school_name}</td>
                    <td className="px-4 py-3 text-[12px]" dir="ltr">{u.email}</td>
                    <td className="px-4 py-3 text-[12px]" dir="ltr">{u.phone || "—"}</td>
                    <td className="px-4 py-3">
                      {u.pledge_accepted ? (
                        <span className="text-[11px] font-bold bg-turq-100 text-turq-900 dark:bg-surface2 dark:text-turq-300 rounded-full px-3 py-1">موثّق</span>
                      ) : (
                        <span className="text-[11px] font-bold bg-coral-100 text-coral-900 dark:bg-surface2 dark:text-coral-300 rounded-full px-3 py-1">قيد الانتظار</span>
                      )}
                    </td>
                    <td className="px-4 py-3 text-[11px]" dir="ltr">{u.pledge_accepted_at ? u.pledge_accepted_at.slice(0, 16).replace("T", " ") : "—"}</td>
                  </tr>
                ))}
              </tbody>
            </table>
          </div>
        </div>
      )}
    </div>
  );
}
